<div class='bems-loader-wrapper' id='bems-loader-wrapper'>
    <div class='bems-loader'>
        <svg class='circular' viewbox='25 25 50 50'>
      <circle class='path' cx='50' cy='50' fill='none' r='20' stroke-miterlimit='10' stroke-width='7'></circle>
      </svg>
    </div>
</div>
<div class="container-fluid header-line-hight-top">
</div>
<div class="container-fluid bg-nav bems-header">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
          <div class="d-flex align-items-center">
            <a class="navbar-brand" routerLink="/home">
              <img class="logo-sm" alt="brand" src="assets/svg/logo.svg" style="height: 5dvh;">
            </a>
            <div class="time-display">
              <div class="time">{{ currentTime | date:'HH:mm' }} <span class="day">{{ currentTime | date:'EEEE' }}</span></div>
              <div class="date">{{ currentTime | date:'dd, MMMM yyyy' }}</div>
            </div>
          </div>

          <div class="d-none d-lg-flex flex-column align-items-end ml-auto">
            <ul class="navbar-nav flex-row align-items-center">
              <li *ngIf="privilege" class="nav-item mx-3">
                <a class="nav-button icon-link">
                  <i *ngIf="bmPage == 'notsamepage'" (click)="bookmark()" class="material-icons" title="Set favaourite page" style="cursor:pointer">star_border</i>
                  <i *ngIf="bmPage == 'samepage'" (click)="bookmark()" class="material-icons" title="Set favaourite page" style="cursor:pointer">star</i>
                </a>
              </li>
              <li *ngIf="privilege && bmStatus == 'havelink' && bmPage == 'notsamepage'" class="nav-item mx-3">
                <a class="nav-button icon-link">
                  <i (click)="goto_bookmark()" class="material-icons" title="Go to favaourite page" style="cursor:pointer">bookmark</i>
                </a>
              </li>
              <li *ngIf="privilege" class="nav-item mx-3"><a class="nav-button icon-link" routerLink="/home/user-setting">
                <i class="material-icons">person</i><span>{{ user }}</span></a>
              </li>
            </ul>
            <ul class="navbar-nav flex-row align-items-center main-menu">
              <li class="nav-item dropdown mx-3">
                <a class="nav-button dropdown-toggle" href="#" id="navbarDropdownMenuDesktop" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">MENU</a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuDesktop">
                  <a class="dropdown-item" routerLink="/home/load-profile">Load Profile</a>
                  <a class="dropdown-item" routerLink="/home/dashboard">Dashboard</a>
                  <!-- <a class="dropdown-item" routerLink="/home/system">Energy Awards</a> -->
                  <a *ngIf="privilege" class="dropdown-item" routerLink="/home/report">Report</a>
                  <a *ngIf="privilege"class="dropdown-item" routerLink="/home/ranking">Ranking</a>
                </div>
              </li>
              <li *ngIf="privilege" class="nav-item mx-3"><a class="nav-button" style="cursor: pointer;" [matMenuTriggerFor]="adminMenu">ADMIN PANEL</a></li>
              <li class="nav-item mx-3"><a class="nav-button" style="cursor: pointer;" data-toggle="modal" data-target="#aboutModal">ABOUT US</a></li>
              <li *ngIf="!privilege" class="nav-item mx-3">
                <a class="nav-button icon-link" routerLink="/login">
                  <i class="material-icons">login</i><span>LogIn</span>
                </a>
              </li>
              <li *ngIf="privilege" class="nav-item mx-3">
                <a class="nav-button icon-link" (click)="logOut()">
                  <i class="material-icons">logout</i><span>LogOut</span>
                </a>
              </li>
            </ul>
          </div>

          <button class="navbar-toggler d-lg-none" type="button" (click)="toggleSidenav()">
            <span class="navbar-toggler-icon"></span>
          </button>

        </nav>
    </div>
</div>
<div id="mobileSidenav" class="sidenav" [class.active]="isSidenavOpen">
  <a href="javascript:void(0)" class="closebtn" (click)="toggleSidenav()">&times;</a>
  <a class="sidenav-item" routerLink="/home/load-profile" (click)="toggleSidenav()">Load Profile</a>
  <a class="sidenav-item" routerLink="/home/dashboard" (click)="toggleSidenav()">Dashboard</a>
  <a id="mobile" *ngIf="privilege" class="sidenav-item" routerLink="/home/report" (click)="toggleSidenav()">Report</a>
  <a *ngIf="privilege" class="sidenav-item" routerLink="/home/ranking" (click)="toggleSidenav()">Ranking</a>
  <a class="sidenav-item" type="button" data-toggle="modal" data-target="#aboutModal" (click)="toggleSidenav()">About</a>

  <a id="mobile" *ngIf="privilege" class="sidenav-item" (click)="toggleSidenav();">
    <span *ngIf="bmPage == 'notsamepage'"><i (click)="bookmark()" class="material-icons" title="Set favaourite page" style="cursor:pointer">star_border</i> Bookmark this page</span>
    <span *ngIf="bmPage == 'samepage'"><i (click)="bookmark()" class="material-icons" title="Set favaourite page" style="cursor:pointer">star</i> Bookmark this page</span>
  </a>
  <a id="mobile" *ngIf="privilege && bmStatus == 'havelink' && bmPage == 'notsamepage'" class="sidenav-item" (click)="toggleSidenav();">
    <i (click)="goto_bookmark()" class="material-icons" title="Set favaourite page" style="cursor:pointer">bookmark</i>Go to Bookmarked page
  </a>
  <a id="mobile" *ngIf="privilege" class="sidenav-item" routerLink="/home/user-setting" (click)="toggleSidenav()"><i class="material-icons">person</i> {{ user }}</a>
  <a *ngIf="!privilege" class="sidenav-item" (click)="toggleSidenav();" routerLink="/login"><i class="material-icons">login</i> LogIn</a>
  <a *ngIf="privilege" class="sidenav-item" (click)="logOut(); toggleSidenav();"><i class="material-icons">logout</i> LogOut</a>

</div>

<mat-menu [hidden]="!privilege" #adminMenu="matMenu">
  <button mat-menu-item routerLink="/admin/system-status">System status</button>
  <button mat-menu-item routerLink="/admin/compare-graph">Compare Graph</button>
  <button mat-menu-item routerLink="/admin/profile-setting">Profile Setting</button>
  <button mat-menu-item routerLink="/admin/point-structure-setting">Point Structure Setting</button>
  <button mat-menu-item routerLink="/admin/notification-setting">Notification Setting</button>
  <button mat-menu-item routerLink="/admin/check-data-notification-setting">Check Data & Notification Setting</button>
  <button mat-menu-item routerLink="/admin/user-management">User Management</button>
  <button mat-menu-item routerLink="/admin/dashboard">Dashboard Setting</button>
  <button mat-menu-item routerLink="/admin/profile-power-setting">Profile Power Setting</button>
  <button mat-menu-item routerLink="/admin/profile-energy-setting">Profile Energy Setting</button>
</mat-menu>

<!-- Modal -->
<div class="bems-about modal fade" id="aboutModal" tabindex="-1" role="dialog" aria-labelledby="aboutModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title bems-about-title" id="aboutModalLabel">KASEM UTHAYANIN BEMS</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="bems-about-body modal-body">
                <div class="row">
                    <div class="col-12">
                        <img class="bems-about-logo" src="./assets/svg/logo.svg">
                        <br>
                        <br>
                    </div>
                    <div class="col-md-6 col-sm-12 col-12">
                        <br><span style="font-size: 16px;"> version 1.1.2 </span>
                        <br/><small>(BEMS Standard Package version 1.3.0)</small>
                        <br>
                        <!-- <small>(Start with BEMS std pkg version 1.2.9)</small> -->
                        <br>
                        <br> Release Date : 29 / 10 / 2025
                    </div>
                    <div class="col-md-6 col-sm-12 col-12">
                        Powered By NDR Solution
                        <br>
                        <img src="./assets/images/logo.jpg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
